<template>
    <div class="mc" >
        <div class="background" :style="{backgroundImage: 'url(' + data[0].question.backgroundImage + ')'}">
        </div>
        <div class="question-container-wrapper">
            <div class="container">
                <div class="viewport" :class="{'continue-button-padding': hasAnswered}">
                    <div class="question">
                        <span v-html="data[0].question.text"/>
                    </div>
                    <div v-if="true || !hasAnswered" class="choice" :class="getItemListPanelClass()">
                        <template v-for="choice in data[0].question.choices">
                            <div class="text" :key="'choice_' + choice.id" @click="selectChoice(choice)">
                                <input v-if="choice.image" type="image" name="ItemImageButton" id="ItemImageButton" :src="choice.image">
                                <a v-html="choice.text"/>
                                <div class="select-outer-ring">
                                    <div v-show="selectedChoiceId == choice.id" class="select-inner-ring">
                                        &nbsp;
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div v-else class="choice" :class="getItemListPanelClass()">
                        <template v-for="choice in data[0].question.choices">
                            <div class="text" :key="'choice_' + choice.id">
                                <input v-if="choice.image" type="image" name="ItemImageButton" id="ItemImageButton" disabled :src="choice.image">
                                <span class="disabled" :class="getChoiceClass(choice)" v-html="choice.text"/>
                            </div>
                        </template>
                    </div>
                </div>                
                <div v-if="hasAnswered" class="continue-button-overlay">
                    <span @click.prevent="onNext" class="continue-button">Verder ></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        'props': {
            data: {}
        },
        data()
        {
            return {
                hasAnswered: false,
                selectedChoiceId: -1,
                itemListPanelClass: 'col1',
            }
        },
        'watch': {
            data: {
                handler() {
                    this.hasAnswered = false;
                    this.selectedChoiceId = -1;

                    if(this.data[0].selectedChoice) {
                        this.hasAnswered = true;
                        this.selectedChoiceId = this.data[0].selectedChoice.id;
                    }
                }
            }
        },
        'methods': {
            'onNext': function() {
                this.$emit('answer', { questionId: this.data[0].question.id, answerParts: [ { answerId: this.selectedChoiceId, answerPart: 'true' } ] });
                this.$emit('next');
            },
            'getItemListPanelClass': function() {
                if(this.answerHasImage()) {
                    return 'col3';
                }
                return 'col1';
            },
            'getChoiceClass': function(choice) {
                if(choice.id == this.selectedChoiceId) {
                    if(choice.isCorrect) {
                        return 'correct';
                    } else {
                        return 'incorrect';
                    }
                }

                return 'disabled';
            },
            'answerHasImage': function() {
                for(var i = 0; i < this.data[0].question.choices.length; i++) {
                    if(this.data[0].question.choices[i].image) {
                        return true;
                    }
                }
                return false;
            },
            'selectChoice': function(choice) {
                if(this.hasAnswered) {
                    return;
                }

                this.hasAnswered = true;
                this.selectedChoiceId = choice.id;

                //this.$emit('answer', { questionId: this.data[0].question.id, answerParts: [ { answerId: this.selectedChoiceId, answerPart: 'true' } ] });

                setTimeout(() => {
                    window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
                });

                // setTimeout(() => {
                //     this.$emit('next');
                // }, 200);
                
            }
        },
        'mounted': function () {
            this.hasAnswered = false;
            this.itemListPanelClass = this.getItemListPanelClass();

            if (this.data[0].selectedChoice) {
                this.hasAnswered = true;
                this.selectedChoiceId = this.data[0].selectedChoice.id;
            }
        }
    }
</script>
